var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinCompanyRtl = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 344,
  height: 232,
  viewBox: "0 0 344 232",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M0 0h220.084v82.663H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M0 0h131.22v43.811H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M0 0h65.61v21.906H0z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "81.633%",
  y1: "42.29%",
  x2: "38.99%",
  y2: "54.094%",
  id: "i"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5EAFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "a",
  x: 0,
  y: 0,
  width: 344,
  height: 232,
  rx: 4
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 344 0)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6467EF",
  d: "M376.642 157.632H-72.653v-171h449.296z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M376.642 281.272H-72.653V157.688h449.296z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 465 -1.933)",
  opacity: 0.867
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.898 20.373C167.663 2.164 144.864-7.84 129.173 7.609c-4.378 4.31-6.76 8.931-10.637 13.268-4.19 4.186-9.003 3.187-12.183-1.885-5.548-8.848-10.65-12.225-20.58-12.901-10.345-.706-17.968 4.502-21.238 10.667-8.7 16.398-1.973 27.621-11.99 36.235-11.674 7.047-18.576-5.57-35.118-4.668-12.845.7-20.192 16.533-16.452 28.643 1.096 3.549 3.679 5.695 7.045 5.695h190.256c10.13 0 21.29-1.115 21.793-15.373.348-9.848-5.546-19.48-14.44-21.142-13.387-2.292-14.433 4.54-22.207 2.79-7.87-1.772-1.564-18.987-7.524-28.565",
  fill: "#D4DAFF",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.797
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(101.175 35.904)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M104.875 10.798c-4.91-9.65-18.503-14.953-27.859-6.765-2.61 2.284-4.03 4.733-6.342 7.032-2.498 2.219-5.367 1.689-7.264-1-3.308-4.689-6.349-6.478-12.27-6.837-6.168-.374-10.713 2.386-12.663 5.654-5.186 8.69-1.176 14.639-7.149 19.204-6.96 3.735-11.075-2.952-20.938-2.474-7.658.372-12.038 8.763-9.809 15.18.654 1.882 2.194 3.02 4.201 3.02h113.435c6.04 0 12.694-.592 12.994-8.148.207-5.22-3.307-10.324-8.61-11.205-7.981-1.215-8.605 2.405-13.24 1.478-4.692-.94-.932-10.063-4.486-15.14",
  fill: "#D4DAFF",
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M141.776 21.661c.036-.246.093-.484.144-.726-.288.266-.562.543-.825.832.228-.033.45-.077.681-.106M125.093 33.528c-.153.194-.293.395-.435.595.126-.022.248-.053.376-.075.01-.175.043-.347.06-.52",
  fill: "#E9E9EA"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.712
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.647 27.38)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M52.438 5.399c-2.455-4.825-9.252-7.476-13.93-3.383-1.305 1.143-2.015 2.367-3.17 3.516-1.25 1.11-2.685.845-3.633-.5-1.654-2.344-3.174-3.239-6.135-3.418-3.084-.187-5.356 1.193-6.331 2.827-2.594 4.345-.588 7.32-3.575 9.602-3.48 1.868-5.537-1.476-10.469-1.237-3.83.186-6.02 4.381-4.904 7.59.326.941 1.096 1.51 2.1 1.51h56.718c3.02 0 6.347-.296 6.497-4.074.103-2.61-1.654-5.162-4.305-5.603-3.991-.607-4.303 1.203-6.62.74-2.347-.47-.467-5.032-2.243-7.57",
  fill: "#F7F9FF",
  mask: "url(#h)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M54.948 20.259c.017-.123.046-.242.072-.363a6.727 6.727 0 0 0-.413.416c.114-.017.225-.039.34-.053M46.606 26.192c-.076.097-.147.198-.218.298.064-.011.125-.027.189-.038.004-.087.02-.173.03-.26",
  fill: "#E9E9EA"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7DFD",
  d: "M354.917 105.759H177.682v-59.46h177.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M354.917 105.759H326.33v-59.46h28.586z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7DFD",
  d: "M326.33 204.095H177.683v-93.762h148.649z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.888 211.835h40.154l-73.86 59.968-278.418 29.798-42.62-120.583c170.908-.654 256.494-1 256.757-1.04.262-.038 32.925 10.58 97.987 31.857z",
  fillOpacity: 0.174,
  fill: "#D7DDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.003 105.105c-2.955 0-5.982.131-9.061.399-83.472 7.253-106.66 75.936-160.897 105.006-38.157 20.451-69.735 15.048-100.257 9.645-23.272-4.12-45.93-8.239-70.422-.899-54.558 16.351-59.646 84.509-59.646 84.509h505.89V187.186c-7.063-22.703-41.944-82.062-105.529-82.081h-.078z",
  fill: "url(#i)",
  transform: "matrix(-1 0 0 1 465 -30)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M354.917 204.095H326.33v-93.762h28.586z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BEFF",
  d: "M326.33 204.095H177.683v-33.16h148.649z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.488 189.666a.677.677 0 0 0-.677.678v1.765c0 .374.303.677.677.677h8.817a.677.677 0 0 0 .677-.677v-1.765a.677.677 0 0 0-.677-.678h-8.817zM215.828 185.89h-8.817a.677.677 0 0 0-.677.677v1.765c0 .374.303.677.677.677h8.817a.677.677 0 0 0 .677-.677v-1.765a.677.677 0 0 0-.677-.678M204.837 185.89h-8.817a.677.677 0 0 0-.677.677v1.765c0 .374.303.677.677.677h8.817a.677.677 0 0 0 .677-.677v-1.765a.677.677 0 0 0-.677-.678M270.935 196.974h-8.817a.677.677 0 0 0-.677.677v1.765c0 .375.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.765a.677.677 0 0 0-.677-.677M276.458 193.197h-8.817a.677.677 0 0 0-.677.677v1.765c0 .374.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.765a.677.677 0 0 0-.677-.677M265.467 193.197h-8.817a.677.677 0 0 0-.677.677v1.765c0 .374.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.765a.677.677 0 0 0-.677-.677",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BEFF",
  d: "M325.61 167.84H177.805v-1.943H325.61zM325.61 164.104H177.805v-1.943H325.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M313.758 203.624h-38.715v-69.79h38.715z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.936 140.193h-29.072c-.714 0-1.294.58-1.294 1.296v35.756c0 .716.58 1.296 1.294 1.296h29.072c.715 0 1.295-.58 1.295-1.296V141.49c0-.716-.58-1.296-1.295-1.296",
  fill: "#E9EDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.865 180.142h29.072c.714 0 1.294.58 1.294 1.296v18.656c0 .715-.58 1.295-1.294 1.295h-29.072c-.716 0-1.295-.58-1.295-1.295v-18.656c0-.716.58-1.296 1.295-1.296",
  fill: "#232E60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.793 163.064a.82.82 0 0 0-.82.821v5.967a.82.82 0 1 0 1.64 0v-5.967a.82.82 0 0 0-.82-.82",
  fill: "#E6EFFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#153B6A",
  d: "M263.585 183.082h-76.741v-51.038h76.74z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9EDFF",
  d: "M261.796 181.292h-73.164v-47.457h73.164z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#244A7B",
  d: "M188.632 172.86v8.432h7.676-7.676z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE3FB",
  d: "M210.052 133.835h12.303l-26.047 47.457h-7.676v-8.432z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#244A7B",
  d: "M198.436 181.291h4.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE3FB",
  d: "M224.483 133.835h4.272l-26.047 47.457h-4.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#244A7B",
  d: "M212.015 181.291h19.548z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE3FB",
  d: "M238.062 133.835h19.548l-26.047 47.457h-19.548z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.393 133.835h.404v7.048-7.048h-.404zm-26.047 47.457h4.272-4.272z",
  fill: "#244A7B"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE3FB",
  d: "M261.393 133.835h.403v7.048l-22.178 40.409h-4.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6467EF",
  d: "M356.997 109.696H174.661v-3.941h182.336zM356.997 102.47H174.661v-3.94h182.336z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M356.997 109.696h-33.766v-3.941h33.766zM356.997 102.47h-33.766v-3.94h33.766z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8597FF",
  d: "M312.987 94.424h-141.58v-41.71h141.58z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M309.41 90.844H174.984V56.296h134.424z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8597FF",
  d: "M309.41 88.216H177.365v-31.92H309.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M320.77 94.424h-7.783v-41.71h7.784z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7DFD",
  d: "M325.61 31.86h-44.948V23.24h44.948z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M336.437 31.86H325.61V23.24h10.827z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7DFD",
  d: "M323.231 46.393h-40.724V31.86h40.724z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M334.181 46.393h-10.95V31.86h10.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29305B",
  d: "M358.911 206.744H174.196v-3.12h184.715z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#404A7F",
  d: "M361.782 211.835H170.341v-5.09h191.441z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.55 130.53h-8.817a.677.677 0 0 0-.677.678v1.766c0 .374.303.677.677.677h8.817a.677.677 0 0 0 .677-.677v-1.766a.677.677 0 0 0-.677-.677M350.073 126.754h-8.817a.677.677 0 0 0-.677.678v1.764c0 .374.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.764a.677.677 0 0 0-.677-.678M339.082 126.754h-8.817a.677.677 0 0 0-.677.678v1.764c0 .374.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.764a.677.677 0 0 0-.677-.678M352.464 181.948h-8.817a.677.677 0 0 0-.677.678v1.765c0 .374.303.677.677.677h8.817a.677.677 0 0 0 .677-.677v-1.765a.677.677 0 0 0-.677-.678M346.996 178.172h-8.817a.677.677 0 0 0-.677.677v1.765c0 .374.303.678.677.678h8.817a.677.677 0 0 0 .677-.678v-1.765a.677.677 0 0 0-.677-.677",
  fill: "#717FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M185.937 173.327h-1.43v4.876l-5.273 5.278-2.484-2.486v-21.133h-1.43v21.726l5.044 5.05v7.216h1.43v-7.81l-1.549-1.55 5.692-5.697z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.96 159.862c0 5.464-4.426 9.894-9.884 9.894-5.459 0-9.884-4.43-9.884-9.894s4.425-9.893 9.884-9.893c5.458 0 9.884 4.429 9.884 9.893M190.334 173.355a5.033 5.033 0 0 1-5.03 5.036 5.033 5.033 0 0 1-5.031-5.036 5.034 5.034 0 0 1 5.03-5.036 5.033 5.033 0 0 1 5.031 5.036",
  fill: "#F83"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#717FFF",
  d: "m171.216 189.666 4.962 13.958h8.982l4.962-13.958z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6EFFF",
  d: "m188.526 194.155.76-2.135h-17.233l.759 2.135zM187.641 196.645l.535-1.505h-15.014l.535 1.505z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.61 112.138v23.812h-15.174l-5.414-8.662s7.342-15.027 20.588-15.15",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m192.542 112.138-8.462 7.418a19.7 19.7 0 0 0-6.714 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.758a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.713-14.817l8.461-7.418h13.384z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m205.924 112.138-8.462 7.418a19.704 19.704 0 0 0-6.712 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.76a6.315 6.315 0 0 1-6.312-6.319v-.678a19.7 19.7 0 0 1 6.714-14.817l8.462-7.418h13.382z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m219.308 112.138-8.462 7.418a19.704 19.704 0 0 0-6.712 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.76a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.384z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m232.69 112.138-8.462 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.311 6.319h-.759a6.315 6.315 0 0 1-6.311-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.382z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m246.073 112.138-8.461 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.76a6.315 6.315 0 0 1-6.311-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.383z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m259.455 112.138-8.461 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.758a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.713-14.817l8.461-7.418h13.382z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m272.839 112.138-8.462 7.418a19.704 19.704 0 0 0-6.712 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.76a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.713-14.817l8.461-7.418h13.384z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m286.22 112.138-8.46 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.758a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.382z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m299.605 112.138-8.462 7.418a19.704 19.704 0 0 0-6.712 14.817v.678a6.315 6.315 0 0 1-6.312 6.319h-.76a6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.384z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m312.986 112.138-8.461 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.311 6.319h-.759a6.315 6.315 0 0 1-6.311-6.319v-.678a19.704 19.704 0 0 1 6.712-14.817l8.462-7.418h13.381z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m325.61 112.138-8.461 7.418a19.704 19.704 0 0 0-6.713 14.817v.678a6.315 6.315 0 0 1-6.312 6.319 6.315 6.315 0 0 1-6.312-6.319v-.678a19.704 19.704 0 0 1 6.713-14.817l8.461-7.418h12.624z",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M280.662 31.635h55.775v.45h-55.775M282.507 46.168h43.103v.45h-43.103M177.805 98.305h145.426v.45H177.805"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#153B6A",
  d: "M323.231 102.695H177.805v-.45h145.426"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M177.805 105.53h145.426v.45H177.805M323.231 109.92H177.805v-.449h145.426"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BEFF",
  d: "M325.61 98.305h29.118v.45H325.61M325.61 102.246h29.118v.45H325.61M325.61 105.754h29.117M325.61 105.53h29.118v.45H325.61M325.61 109.695h29.117M325.61 109.471h29.118v.45H325.61"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#586093",
  d: "M275.043 203.624v.225H313.3l-2.031 2.622v.273h-40.425z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6772AB",
  d: "M270.843 206.744h40.425v4.907l-.227.184h-40.153l.179-5.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BEFF",
  d: "M313.758 203.4h.458l-.174.224h-.284z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50578B",
  d: "M313.757 203.624h-38.714v-.225h38.714z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#586093",
  d: "m270.618 206.736.224.008h.001-.226z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6772AB",
  d: "M270.618 206.744h.226l.223.008-.179 5.083h-.847l.403-.147z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#586093",
  d: "M275.043 203.624h38.999l-2.325 3.001v.12h-.45v-.274l2.032-2.622h-38.256z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6772AB",
  d: "M311.268 206.744h.45v5.09h-.676l.226-.183z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3BEFF",
  d: "M325.61 203.625h29.117M325.61 203.4h29.118v.449H325.61"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M177.366 56.07h132.268v32.146h-.45V56.52H177.367z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.423 159.234h-15.226a1.872 1.872 0 0 1-1.871-1.872v-4.686c0-1.035.837-1.873 1.87-1.873h15.227c1.033 0 1.871.838 1.871 1.873v4.686a1.872 1.872 0 0 1-1.87 1.872",
  fill: "#8597FF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1C224F",
  d: "M176.076 73.21h59.195l23.156-17.095.266.361L235.42 73.66h-59.343zM291.047 151.312c.002-.006.48-1.78 1.24-3.573.381-.897.83-1.798 1.335-2.491.253-.347.52-.643.808-.86.286-.217.6-.358.937-.365h.026c.336 0 .652.136.942.35.506.375.959.991 1.374 1.708 1.238 2.148 2.108 5.22 2.112 5.228l-.433.123s-.03-.109-.09-.302c-.206-.675-.757-2.373-1.487-3.888-.364-.757-.774-1.468-1.199-1.977a2.97 2.97 0 0 0-.633-.592c-.207-.135-.402-.201-.586-.201h-.017c-.212.004-.438.095-.676.275-.416.311-.844.89-1.23 1.578-.582 1.034-1.082 2.314-1.434 3.332-.176.51-.315.953-.41 1.269-.095.316-.145.503-.146.503l-.433-.117z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.881 74.784h-53.73a3.54 3.54 0 0 0-3.537 3.541v26.386a3.538 3.538 0 0 0 3.536 3.54h53.731a3.539 3.539 0 0 0 3.537-3.54V78.325a3.538 3.538 0 0 0-3.537-3.54",
  fill: "#071B33"
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.018 85.562h1.281l.439-4.145h.017l.439 4.145h1.202l.622-6.147h-.833l-.43 4.725h-.017l-.457-4.725h-1.052l-.456 4.725h-.018l-.43-4.725h-.93l.623 6.147zm4.49 0h2.632v-.878h-1.667v-1.888h1.325v-.878h-1.325v-1.625h1.667v-.878h-2.632v6.147zm4.332 0h.895l.175-1.203h1.097v-.018l.175 1.221h.966l-1-6.147h-1.308l-1 6.147zm1.184-2.037.422-3.039h.017l.43 3.039h-.869zm2.587 2.037h.965v-2.634h.334c.438 0 .605.184.605.755v1.124c0 .5.035.597.087.755h.983c-.096-.228-.105-.448-.105-.746v-1.08c0-.694-.158-1.15-.64-1.3v-.018c.43-.175.631-.58.631-1.212v-.377c0-.949-.43-1.414-1.43-1.414h-1.43v6.147zm.965-3.512v-1.757h.439c.342 0 .491.193.491.632v.475c0 .491-.22.65-.579.65h-.351zm2.57 3.512h2.631v-.878h-1.667v-1.888h1.325v-.878h-1.325v-1.625h1.667v-.878h-2.632v6.147zM295.265 104.42c2.71 0 4.19-1.608 4.19-4.42v-9.24c0-2.813-1.48-4.42-4.19-4.42-2.709 0-4.189 1.607-4.189 4.42V100c0 2.812 1.48 4.42 4.19 4.42zm0-2.512c-.878 0-1.43-.477-1.43-1.732v-9.592c0-1.256.552-1.733 1.43-1.733.878 0 1.43.477 1.43 1.733v9.592c0 1.255-.552 1.732-1.43 1.732zm6.046 2.26h2.76v-7.156h1.304c2.76 0 4.114-1.532 4.114-4.345v-1.732c0-2.812-1.355-4.344-4.114-4.344h-4.064v17.577zm2.76-9.667v-5.399h1.304c.878 0 1.354.401 1.354 1.657v2.084c0 1.256-.476 1.658-1.354 1.658h-1.305zm6.923 9.667h7.525v-2.511h-4.766v-5.398h3.788v-2.512h-3.788v-4.645h4.766v-2.51h-7.525v17.576zm9.106 0h2.458V91.337h.05l3.312 12.831h2.835V86.591h-2.459v10.521h-.05l-2.684-10.52H320.1v17.576z",
  fill: "#071B33"
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.804 73.435a3.54 3.54 0 0 0-3.538 3.541v26.387a3.538 3.538 0 0 0 3.537 3.54h53.731a3.539 3.539 0 0 0 3.537-3.54V76.976a3.538 3.538 0 0 0-3.537-3.54h-53.73z",
  fill: "#F83"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.553 84.84c-.948 0-1.404-.483-1.404-1.493v-4.69h.965v4.716c0 .405.184.589.57.589.105 0 .21-.01.316-.035v.878c-.14.026-.272.035-.447.035zm-3.49.053c-.949 0-1.466-.562-1.466-1.546v-3.232c0-.983.517-1.545 1.465-1.545.947 0 1.465.562 1.465 1.545v3.232c0 .984-.518 1.546-1.465 1.546zm0-.878c.306 0 .499-.167.499-.607v-3.354c0-.44-.193-.606-.5-.606s-.5.167-.5.606v3.354c0 .44.193.607.5.607zm-2.114.79h-.965v-6.147h.965v6.147zm-1.684 0h-.86v-4.488h-.017l-1.158 4.488h-.991v-6.147h.86v3.68h.017l.939-3.68h1.21v6.147zm-4.893 0h-.895l-.176-1.203h-1.096v-.018l-.176 1.221h-.964l1-6.147h1.307l1 6.147zm-1.185-2.037-.42-3.039h-.018l-.43 3.039h.868zM331.359 102.14c-2 0-3.057-1.209-3.057-3.249v-1.87h1.962v2.022c0 .868.416 1.209 1.038 1.209.623 0 1.038-.34 1.038-1.21v-7.385c0-.868-.415-1.228-1.038-1.228-.622 0-1.038.36-1.038 1.228v1.53h-1.962V91.79c0-2.04 1.057-3.249 3.057-3.249s3.056 1.209 3.056 3.249v7.101c0 2.04-1.056 3.25-3.056 3.25zm-7.339 0c-2.038 0-3.15-1.209-3.15-3.324v-6.95c0-2.116 1.112-3.325 3.15-3.325s3.151 1.209 3.151 3.324v6.95c0 2.116-1.113 3.325-3.15 3.325zm0-1.888c.66 0 1.076-.36 1.076-1.304v-7.215c0-.944-.415-1.304-1.076-1.304-.66 0-1.075.36-1.075 1.304v7.215c0 .944.415 1.304 1.075 1.304zm-4.546 1.7h-1.811V91.94h-.038l-1.51 10.01h-1.735l-1.51-10.01h-.037v10.01h-1.963V88.73h2.962l1.321 9.463h.038l1.321-9.463h2.962v13.221zm-10.15 0h-2.075v-5.384h-.98c-2.076 0-3.096-1.152-3.096-3.267v-1.304c0-2.115 1.02-3.267 3.095-3.267h3.057v13.221zm-2.075-7.273v-4.06h-.98c-.661 0-1.02.302-1.02 1.246v1.568c0 .944.359 1.246 1.02 1.246h.98zm-3.999 7.272h-1.924l-.378-2.587h-2.358v-.038l-.378 2.625h-2.075l2.15-13.221h2.812l2.151 13.221zm-2.547-4.382-.906-6.535h-.037l-.925 6.535h1.868zm-5.565 4.382h-1.849V92.3h-.037l-2.491 9.652h-2.132V88.73h1.849v7.914h.038l2.018-7.914h2.604v13.221zm-9.96 0h-2.076v-5.628l-2.51-7.593h2.02l1.414 4.854h.038l1.415-4.854h2.208l-2.51 7.593v5.628z",
  fill: "#FFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinCompanyRtl);
export default ForwardRef;